<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column">
      <div style="margin-bottom: 32px;">
        <h3>Instructions</h3>

        <div>
          <span class="Vlt-number Vlt-bg-black" data-index="1"></span>
          <span>Scan the QR Code or click the link below to download the APK</span>
        </div>

        <div>
          <span class="Vlt-number Vlt-bg-black" data-index="2"></span>
          <span>Install the APK onto your Android Phone</span>
        </div>

        <div>
          <span class="Vlt-number Vlt-bg-black" data-index="3"></span>
          <span>View the Guide for more info</span>
        </div>

      </div>

      <img src="https://vids.vonage.com/pages/inapp-android/qr4.png" width="240" height="240" alt="qrcode" />
      <div style="width: 240px; text-align: center">
        <a href="https://vids.vonage.com/pages/inapp-android/app-20201021-1524.apk">Click to Download APK</a>
      </div>
    </div>

  </section>

</template>

<script lang="js">
export default {
  name: 'demo',
  props: {
    nexmo: {
      type: Object,
      required: false
    }
  },
}
</script>

<style scoped lang="scss"></style>